import { useQuery as useReactQuery } from '@tanstack/react-query'
import { flatten, join, values } from 'lodash'

const baseUrl = "/api"

export default function useQuery(key: string, id: string | null = null, options = {}) {
  const path = id ? `${key}/${id}/` : `${key}/`
  const url = `${baseUrl}/${path}`
  
  return useReactQuery({
    queryKey: [path],
    queryFn: async () => {
      const response = await fetch(
        url,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${localStorage.getItem("token")}`,
          }
        }
      )      
      const json = await response.json()
      if (response.status === 401 && window.location.pathname !== "/login") {
        window.location.href = "/login"
        return
      }

      if (!response.ok) {
        const errorMessage = join(flatten(values(json)))
        throw new Error(errorMessage)
      }
      
      return json
    },
    ...options
  })
}
